module.exports = __webpack_public_path__ + "static/logo-7389995bfec44ca3882900b99843b7f0.png";